
import req from '../utils/request.js'

const homeReq = {}

// 推荐馆藏
homeReq.requestcoll = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/home/showcollection', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
homeReq.requestcollNew = function(params) {
  return new Promise((resolve, reject) => { //add by sxz 2022.3.3
    req.get('/adks-app/pc/apiv1/home/recommends', params).then(res => {
      resolve(res)

      console.log('馆藏推荐：' + res)

    }).catch(error => {
      reject(error)
    })
  })
}



// 特色专题
homeReq.requesttopic = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/home/topicalTopic', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 推荐用户
homeReq.requestuser = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/pc/apiv1/home/showUser', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 首页获取轮播图
homeReq.requestbanner = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/home/banners', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取客户端配置
homeReq.requestclient = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/home/client', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取客户端配置
homeReq.homeTenant = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/pc/apiv1/home/tenant', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取首页资源数量
homeReq.resourceTypeCount = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/collection/resourceTypeCount', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取首页学科
homeReq.subjectList = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/subject/list', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取首页分类
homeReq.categoryList = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/category/list', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 纪事人物
homeReq.referPerson = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/home/referPerson', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
export default homeReq
